/**
 * Created by akirilyuk on 12/5/16.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");

    var KEYS = {
        SUBJECT: "subject",
        DESCRIPTION: "description",
        REPLICATION: "replication",
        SCOPE: "scope",
        FIRST_NOTICED: "first_noticed",
        CHANGES: "changed",
        PHONE: "phone",
        VISIBILITY: "visibility",
        NAME: "name",
        EMAIL: "email",
        SEVERITY: "severity",
        TOPIC: "topic",
        PLATFORM: "platform",
        OS_VERSION: "os_version",
        DEVICE_VERSION: "device_version",
        SDK_VERSION: "sdk_version"
    };

    var CreateTicketStorageModel = {};
    LE.module("LEConnection", function () {
        CreateTicketStorageModel = BaseModel.extend({
            name: "CreateTicketStorageModel",

            setSubject: function (value) {
                this.set(KEYS.SUBJECT, value);
            },

            getSubject: function () {
                return this.get(KEYS.SUBJECT);
            },

            setDescription: function (value) {
                this.set(KEYS.DESCRIPTION, value);
            },

            getDescription: function () {
                return this.get(KEYS.DESCRIPTION);
            },

            setReplication: function (value) {
                this.set(KEYS.REPLICATION, value);
            },

            getReplication: function () {
                return this.get(KEYS.REPLICATION);
            },

            setScope: function (value) {
                this.set(KEYS.SCOPE, value);
            },

            getScope: function () {
                return this.get(KEYS.SCOPE);
            },

            setFirstNoticed: function (value) {
                this.set(KEYS.FIRST_NOTICED, value);
            },

            getFirstNoticed: function () {
                return this.get(KEYS.FIRST_NOTICED);
            },

            setPreeceedingChanges: function (value) {
                this.set(KEYS.CHANGES, value);
            },

            getPreceedingChanges: function () {
                return this.get(KEYS.CHANGES);
            },

            setPhone: function (value) {
                this.set(KEYS.PHONE, value);
            },

            getPhone: function () {
                return this.get(KEYS.PHONE);
            },

            setVisibility: function (value) {
                this.set(KEYS.VISIBILITY, value);
            },

            getVisibility: function () {
                return this.get(KEYS.VISIBILITY);
            },

            getName: function () {
                return this.get(KEYS.NAME);
            },

            setName: function (name) {
                this.set(KEYS.NAME, name);
            },

            getEmail: function () {
                return this.get(KEYS.EMAIL);
            },

            setEmail: function (email) {
                this.set(KEYS.EMAIL, email);
            },

            setCaseSeverity: function (severity) {
                this.set(KEYS.SEVERITY, severity);
            },

            getCaseSeverity: function () {
                return this.get(KEYS.SEVERITY);
            },

            setCaseTopic: function (topic) {
                this.set(KEYS.TOPIC, topic);
            },

            getCaseTopic: function () {
                return this.get(KEYS.TOPIC);
            },

            setCasePlatform: function (value) {
                this.set(KEYS.PLATFORM, value);
            },

            getCasePlatform: function () {
                return this.get(KEYS.PLATFORM);
            },

            setSdkVersion: function (value) {
                this.set(KEYS.SDK_VERSION, value);
            },

            getSdkVersion: function () {
                return this.get(KEYS.SDK_VERSION);
            },

            setOsVersion: function (value) {
                this.set(KEYS.OS_VERSION, value);
            },

            getOsVersion: function () {
                return this.get(KEYS.OS_VERSION);
            },

            setDeviceVersion: function (value) {
                this.set(KEYS.DEVICE_VERSION, value);
            },

            getDeviceVersion: function () {
                return this.get(KEYS.DEVICE_VERSION);
            }
        });
    });
    return CreateTicketStorageModel;
});
